// Cookies are stored in the document, so don't try to use this in SSR, it makes no sense
export const getCookie = (name: string): string | null => {
  const nameEq = `${name}=`;
  const cookies = document.cookie.split(/\s*;\s*/);

  const cookie = cookies.find(c => c.startsWith(nameEq));
  if (cookie) {
    return cookie.substring(nameEq.length, cookie.length);
  }
  return null;
};

export const setCookie = (key: string, value: string, expiryHours?: number): void => {
  let cookieString = `${key}=${value};path=/;`;

  if (expiryHours !== undefined) {
    const expiryDate = new Date(Date.now() + expiryHours * 60 * 60 * 1000);
    cookieString += `expires=${expiryDate.toUTCString()};`;
  }
  // If expiryHours is undefined, creates a session cookie (expires on browser close)

  document.cookie = cookieString;
};

export const removeCookie = (key: string): void => {
  document.cookie = `${key}=;path=/;Max-Age=-1`;
};
